import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { desktop, laptop, tabletL, tabletS, mobile } from '@/utils/media'
import { mq, aspectRatio, aspectRatioChild } from '@/utils/helpers'
import Section from '@/components/common/Section'
import Typography from '@/components/common/Typography'
import ParticleBackground from '@/components/common/ParticleBackground'
import Image from '@/components/common/Image'

const CompanyBlock = ({ theme, type, images, title, body, ...other }) => (
  <Root>
    <Section
      subtitle={title.sub}
      title={title.main}
    >
      <Main>
        {images && images.length && (
          <Images>
            <Images_Container>
              {images.map((image, index) => (
                <Images_Child key={index} >
                  <Image css={styles.Image} fluid={image.childImageSharp.fluid} />
                </Images_Child>
              ))}
            </Images_Container>
          </Images>
        )}
        <Content type={type} theme={theme}>
          {type === 'particle' && (
            <Background scale={400} />
          )}
          <Body variant="body2">{body}</Body>
        </Content>
      </Main>
    </Section>
  </Root>
)

const Root = styled.div``

const Main = styled.div``

const Images = styled.div`
  @media ${mq.and(desktop, laptop, tabletL, tabletS)} {
    ${aspectRatio(964, 360)};
  }
`

const Images_Container = styled.div`
  display: flex;
  @media ${mq.and(desktop, laptop, tabletL, tabletS)} {
    ${aspectRatioChild};
  }
  @media ${mq.and(mobile)} {
    flex-direction: column;
  }
`

const Images_Child = styled.div`
  width: 0;
  height: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  @media ${mq.and(mobile)} {
    width: 100%;
    ${aspectRatio(964, 360)};
  }
`

const Content = styled.div`
  position: relative;
  padding: 48px 64px 64px;
  @media ${mq.and(tabletL)} {
    padding: 48px 32px 64px;
  }
  @media ${mq.and(tabletS)} {
    padding: 32px 32px 48px;
  }
  @media ${mq.and(mobile)} {
    padding: 32px 16px 48px;
  }
  background-color: ${props => props.type === 'particle'
    ? 'transparent'
    : props.theme.scale[800]
  };
`

const Background = styled(ParticleBackground)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const Body = styled(Typography)`
  position: relative;
`

const styles = {
  Image: css`
    @media ${mq.and(mobile)} {
      position: absolute !important;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  `
}

export default ThemeConsumer(CompanyBlock)
